import { Box } from '@mui/material';
import StyledTooltip from '../../common/StyledTooltip';
import { getObjectTypeColor } from '../../sweep-canvas/helpers/getObjectTypeColor';
import { Tag } from '@sweep-io/sweep-design';
import { ObjectTypeLabelAndKeyTag } from '../../common/ObjectTypeLabelAndKey';

const RuleChips = ({
  chips,
  differentColorChips,
  differentColor = '',
}: {
  chips: string[];
  differentColorChips?: string[];
  differentColor?: string;
}) => {
  const chipsToShow = chips.slice(0, 2);
  const chipsLeft = chips.slice(2);
  const chipsLeftCount = chipsLeft.length;
  const tooltipText = chipsLeftCount ? chipsLeft.join(', ') : '';
  const { step: defaultColor } = getObjectTypeColor();
  return (
    <Box alignItems="flex-end" display="flex" gap={0.5}>
      {chipsToShow?.map((text, index) => {
        const { step: objectColor } = getObjectTypeColor(text); //if the chip is not an object, the color will be the default
        return (
          <ObjectTypeLabelAndKeyTag
            key={`${text}-${index}`}
            objectType={text}
            background={differentColorChips?.includes(text) ? differentColor : objectColor}
            tagVariant="tiny"
          />
        );
      })}
      {chipsLeftCount > 0 && (
        <Box>
          <StyledTooltip title={tooltipText}>
            <Box display="flex">
              <Tag size="tiny" color={defaultColor} label={'+' + chipsLeftCount} />
            </Box>
          </StyledTooltip>
        </Box>
      )}
    </Box>
  );
};

export default RuleChips;
